<template>
  <div id="contenedor-main-obra">
    <v-container
      fluid>
      <v-card
        v-if="!esProyecto"
        flat
        class="mb-4">
        <v-card-text>
          <titulo-tool-bar
            :titulo="getObra.clave">
          </titulo-tool-bar>
          <opciones-tool-bar></opciones-tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <router-view></router-view>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import OBRA from '@/graphql/querys/administracion/planeacion/obra.gql';
import TituloToolBar from './TituloToolBar.vue';
import OpcionesToolBar from './OpcionesToolBar.vue';

export default {
  name: 'MainObra',
  props: {
    esProyecto: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    TituloToolBar,
    OpcionesToolBar,
  },
  data() {
    return {
    };
  },
  apollo: {
    obra: {
      query: OBRA,
      variables() {
        return {
          id: this.$route.params.idObra,
        };
      },
    },
  },
  computed: {
    getObra() {
      if (!this.obra) return {};
      return this.obra;
    },
  },
};
</script>

<style lang="scss">

</style>
